module.exports = __webpack_public_path__ + "img/AVEILCLogo.4e99c33b.svg";